<template>
  <a class="benefit-button" :href="downloadUrl || 'javascript:;'" :download="downloadUrl ? true : false">
    <slot></slot>
  </a> 
</template>

<script>
export default {
  name: 'benefit-button',
  props: {
    downloadUrl: {
      type: String
    }
  }
}
</script>

<style lang="scss">
.benefit-button {
  display: block;
  margin: 0 16px 21px 16px;/*no*/
  border: none;
  text-decoration: none;
  line-height: 40px;/*no*/
  text-align: center;
  height: 40px;/*no*/
  border-radius: 22px;/*no*/
  background-image: linear-gradient(90deg, #3373ff 0%, #0050ff 100%);
  font-size: 16px;/*no*/
  color: #ffffff;
  text-align: center;
}
</style>
